import 'floating-vue/dist/style.css'
import 'intro.js/minified/introjs.min.css'

import { createApp } from "vue"
import { createPinia } from 'pinia'
import { VTooltip, Tooltip, Dropdown, Menu } from 'floating-vue'
import { appGlobalErrorsHandler, appGlobalWarningsHandler } from "./errors/utils"
import { useNotifications } from "./store/notifications.store"
import { initSentry } from "./errors/sentry"

import App from "./App.vue"
import router from "./router"
import clickOutside from './directives/click-outside'

import Echo from "laravel-echo";
import Pusher from "pusher-js";

const pinia = createPinia()

const app = createApp(App)
    .directive('click-outside', clickOutside)
    .directive('tooltip', VTooltip)
    .component('VTooltip', Tooltip)
    .component('VDropdown', Dropdown)
    .component('VMenu', Menu)

initSentry(app, router);

app.config.errorHandler = appGlobalErrorsHandler(useNotifications);
app.config.warnHandler = appGlobalWarningsHandler(useNotifications);

app.use(router)
app.use(pinia)

window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true
});

//Subscribe to the channel we specified in our Adonis Application
app.mount("#app")
